"use client";

import * as React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Leaf } from "lucide-react";
function ToursGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-3xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground">
        Unable to load tours at this time.
      </div>;
  }
  if (products.length === 0) {
    return <div className="text-center text-muted-foreground">
        No tours available yet. Check back soon!
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group relative overflow-hidden rounded-3xl border-0 bg-white shadow-soft transition-all duration-[200ms] ease-[cubic-bezier(0.4,0,0.2,1)] hover:shadow-strong hover:-translate-y-2">
          <Link to={product.link}>
            <div className="relative aspect-[4/3] overflow-hidden rounded-t-3xl bg-muted">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-[200ms] ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-primary/10">
                  <span className="text-sm text-muted-foreground">No image available</span>
                </div>}
              
              <Badge className="absolute top-4 right-4 bg-accent text-foreground-accent shadow-medium animate-[bounce_2s_ease-in-out_infinite] border-0 rounded-full px-3 py-1.5">
                <Leaf className="w-3 h-3" />
                Eco-Certified
              </Badge>
            </div>
          </Link>

          <CardContent className="space-y-3 px-6 pb-6">
            <Link to={product.link}>
              <h3 className="font-display text-xl font-semibold leading-tight text-foreground transition-colors duration-[150ms] group-hover:text-primary-dark">
                {product.title}
              </h3>
            </Link>

            {product.short_description && <p className="text-sm text-muted-foreground line-clamp-2">
                {product.short_description}
              </p>}

            <div className="flex items-center justify-between pt-2">
              <div className="flex flex-col">
                {product.discounted_price !== undefined ? <>
                    <span className="text-xs text-muted-foreground line-through">
                      ${product.price.toFixed(2)}
                    </span>
                    <span className="text-2xl font-bold text-secondary-dark">
                      ${product.discounted_price.toFixed(2)}
                    </span>
                  </> : <span className="text-2xl font-bold text-foreground">
                    ${product.price.toFixed(2)}
                  </span>}
              </div>

              <div className="opacity-0 transition-opacity duration-[150ms] group-hover:opacity-100">
                <Badge variant="outline" className="rounded-full border-primary text-primary-dark bg-primary-light">
                  per person
                </Badge>
              </div>
            </div>

            <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-foreground-primary" text="Book Now" showQuantity={false} variant="default" />
          </CardContent>
        </Card>)}
    </div>;
}
export default function FeaturedToursSection() {
  return null;
}